import { DialogBody, DialogHeader } from "common/components/ui/Dialog";
import { DrawerBody, DrawerHeader } from "common/components/ui/Drawer";
import {
  typedObjectKeys,
  typeSafeObjectFromEntries,
} from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { LEAD_LIST_SOURCE_TYPES } from "../../../constants";
import SourceRow from "./SourceRow";

interface LinkedInImportProps {
  listId: string;
  goBack: () => void;
}

const LINKEDIN_SEARCH_OPTIONS_KEYS = ["search", "navigator"] as const;
const LINKEDIN_ENGAGEMENT_OPTIONS_KEYS = ["post", "event", "group"] as const;

export const LINKEDIN_SEARCH_OPTIONS = typeSafeObjectFromEntries(
  LINKEDIN_SEARCH_OPTIONS_KEYS.map((key) => {
    const { icon, label, subtitle, iconContainerClassName } =
      LEAD_LIST_SOURCE_TYPES[key];
    return [key, { icon, label, subtitle, iconContainerClassName }] as const;
  }),
);

export const LINKEDIN_ENGAGEMENT_OPTIONS = typeSafeObjectFromEntries(
  LINKEDIN_ENGAGEMENT_OPTIONS_KEYS.map((key) => {
    const { icon, label, subtitle, iconContainerClassName } =
      LEAD_LIST_SOURCE_TYPES[key];
    return [key, { icon, label, subtitle, iconContainerClassName }] as const;
  }),
);
export default function LinkedInImport({
  listId,
  goBack,
}: LinkedInImportProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Body = isDesktop ? DialogBody : DrawerBody;

  return (
    <>
      <Header title="Import from LinkedIn" onBack={goBack} />
      <Body>
        <h6 className="pl-1 mb-1.5 text-black-400 text-button-xs">Search</h6>
        <div className="flex flex-col">
          {typedObjectKeys(LINKEDIN_SEARCH_OPTIONS).map((key) => (
            <SourceRow
              key={key}
              sourceType={key}
              to={`lists/${listId}/sources/new/${key}`}
            />
          ))}
        </div>
        <h6 className="pl-1 mb-1.5 text-black-400 text-button-xs mt-6">
          Engagement
        </h6>
        <div className="flex flex-col">
          {typedObjectKeys(LINKEDIN_ENGAGEMENT_OPTIONS).map((key) => (
            <SourceRow
              key={key}
              sourceType={key}
              to={`lists/${listId}/sources/new/${key}`}
            />
          ))}
        </div>
      </Body>
    </>
  );
}
